/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdateCorporateDocumentResultRequest
 */
export interface UpdateCorporateDocumentResultRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCorporateDocumentResultRequest
     */
    'result': UpdateCorporateDocumentResultRequestResultEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateCorporateDocumentResultRequest
     */
    'reason': string | null;
}

export const UpdateCorporateDocumentResultRequestResultEnum = {
    approved: 'APPROVED',
    denied: 'DENIED'
} as const;

export type UpdateCorporateDocumentResultRequestResultEnum = typeof UpdateCorporateDocumentResultRequestResultEnum[keyof typeof UpdateCorporateDocumentResultRequestResultEnum];


